import { defineComponent } from 'vue'
import type { ExtractPropTypes } from 'vue'
import { ElButton } from 'element-plus'


export const pagetableCellButtonProps = () => ({
  type: String,
})

export type PagetableCellButtonProps = Partial<ExtractPropTypes<ReturnType<typeof pagetableCellButtonProps>>>

export default defineComponent({
  name: 'OPagetableCellButton',
  inheritAttrs: false,
  props: pagetableCellButtonProps(),
  emits: ['click'],
  setup(props, { slots, attrs, emit, expose }) {
    const handleClick = (event: Event) => {
      emit('click', event)
    }

    return () => {
      const { type } = props
      const children = slots.default?.()

      return (
        <ElButton link type={type} size="small" onClick={handleClick}>
          {children}
        </ElButton>
      )
    }
  },
})
